import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import ChannelSelect from 'components/ChannelSelect'
import {Table, Column, Cell} from 'components/Table'
import {fetchUnmappedReferrers, mapReferrers} from 'redux/modules/settings/actions'
import {
  getUnmappedReferrers,
  getMapUnmappedChannelSaving
} from 'redux/modules/settings/selectors'
import classnames from 'classnames'
import {connect} from 'react-redux'
import _ from 'lodash'
import ChannelGroupTitle from 'components/ChannelGroupTitle'
import ChannelTitle from 'components/ChannelTitle'

export class UmMappedView extends React.Component {
  static propTypes = {
    fetchUnmappedReferrers: PropTypes.func,
    mapReferrers: PropTypes.func,
    unmappedReferrers: PropTypes.array,
    isReferrerMappingsFetching: PropTypes.bool
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedReferer: {},
      selectedChannel: null
    }
  }

  componentWillMount() {
    const {fetchUnmappedReferrers} = this.props
    fetchUnmappedReferrers()
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedChannel: null,
      selectedReferer: {}
    })
  }

  render() {
    return (
      <div className='unmapped-view'>
        {this.renderUnmappedChannels()}
        {this.renderMappingForm()}
      </div>
    )
  }

  renderUnmappedChannels() {
    const {unmappedReferrers, isReferrerMappingsFetching} = this.props

    return (
      <div className='settings-unmapped-view_channels'>
        <div className='settings-unmapped-view_channels_intro'>
        Below are the HTTP Referrers currently recognized as Referral/Other.
        Select the parameters you want to map to another Channel and choose the correct Channel Group and Channel to the right.
        </div>
        <Table
          className='settings-unmapped-view_channels_table'
          data={unmappedReferrers}
          loading={isReferrerMappingsFetching}
          empty='There are no referrer mapping'
        >
          <Column
            header='HTTP REFERRERS'
            cell={data =>
              <Cell className='settings-unmapped-view_channels_table_url-cell'>
                {this.renderRefererReferer(data.domain)}
              </Cell>}
          />
          <Column
            header='Channel Group'
            grow
            width={140}
            cell={data => (
              <Cell>
                <ChannelGroupTitle id={data.channelGroup} />
              </Cell>
            )}
          />
          <Column
            header='Channel'
            grow
            width={140}
            cell={data => (
              <Cell>
                <ChannelTitle id={data.channel} iconSize='16px' />
              </Cell>
            )}
          />
          <Column
            header='Visits'
            width='100px'
            className='settings-unmapped-view_channels_table_visits'
            cell={data => <Cell className='settings-unmapped-view_channels_table_visits'>{data.visit}</Cell>}
          />
        </Table>
      </div>
    )
  }

  renderRefererReferer(data) {
    const referers = data
    const {selectedReferer} = this.state

    const active = selectedReferer['referer'] && selectedReferer['referer'].includes(referers)

    const classNames2 = classnames('url-part_token', {
      'is-active': active
    })
    return (
      <div className='is-matched'>
        <div className='url-part' onClick={() => this.handleMappingClick('referer', referers)}>
          <span className={classNames2}>
            {referers}
          </span>
        </div>
      </div>
    )
  }

  renderMappingForm() {
    return (
      <div className='settings-unmapped-view_form'>
        <div className='settings-unmapped-view_form_title'>
          Create a new mapping
        </div>
        {this.renderMappings()}
        {this.renderChannelSelect()}
      </div>
    )
  }

  renderMappings() {
    const {selectedReferer} = this.state
    const referer = selectedReferer['referer'] ? selectedReferer['referer'] : []
    return (
      <div className='settings-unmapped-view_form_mappings no_padding_bottom'>
        From now on, whenever we encounter the selected HTTP Referrer we will map to this channel:
        {Object.keys(referer).map((param, index) => {
          const value = referer[param]
          if (!value) return null
          const paramValue = `${value}`
          return (
            <div key={index} className='settings-unmapped-view_form_mapping'>
              <Icon className='settings-unmapped-view_form_mapping_icon' name='chevron' size='10px' />
              {paramValue}
            </div>
          )
        })}
      </div>
    )
  }

  renderChannelSelect() {
    const {selectedChannel} = this.state
    const disabled = !(this.hasActiveParameter() && selectedChannel)

    return (
      <div className='settings-unmapped-view_form_channel'>
        <ChannelSelect
          className='settings-unmapped-view_form_select'
          value={selectedChannel}
          onChannelSelect={this.selectChannel}
        />

        <button
          type='submit'
          className='settings-unmapped-view_form_submit'
          onClick={this.saveRefererMapping}
          disabled={disabled}>
          Save
        </button>
      </div>
    )
  }

  handleMappingClick = (type, value) => {
    const {selectedReferer} = this.state

    const refererValue = _.xor(selectedReferer[type], [value])
    if (refererValue) {
      this.setState({
        selectedReferer: {
          ...selectedReferer,
          [type]: refererValue
        }
      })
    } else {
      this.setState({
        selectedReferer: _.omit(selectedReferer, [type])
      })
    }
  }

  hasActiveParameter() {
    const {selectedReferer} = this.state

    return Object.keys(selectedReferer)
      .find(param => !!selectedReferer[param])
  }

  selectChannel = item => {
    if (!item) {
      this.setState({selectedChannel: null})
    } else {
      const {channelTypeId, channelGroupId, channelId} = item
      if (!channelGroupId || !channelId) {
        this.setState({selectedChannel: null})
      } else {
        this.setState({
          selectedChannel: {channelTypeId, channelGroupId, channelId}
        })
      }
    }
  }

  saveRefererMapping = () => {
    const {mapReferrers} = this.props
    const {
      selectedReferer,
      selectedChannel
    } = this.state

    const disabled = !(this.hasActiveParameter() && selectedChannel)
    if (disabled) return

    const {channelTypeId, channelGroupId, channelId} = selectedChannel

    mapReferrers({
      selectedReferer,
      channelTypeId,
      channelGroupId,
      channelId
    })
  }
}

const mapStateToProps = state => ({
  unmappedReferrers: getUnmappedReferrers(state),
  isMapUnmappedChannelSaving: getMapUnmappedChannelSaving(state),
  isReferrerMappingsFetching: state.settings.isReferrerMappingsFetching
})

export default connect(mapStateToProps, {
  fetchUnmappedReferrers,
  mapReferrers
})(UmMappedView)



// WEBPACK FOOTER //
// ./client/views/SettingsReferrerMappingView/UnMappedView.js